import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Mitarbeiter';
import { Qualifikationen } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard/Qualifikationen';
import { useState } from 'react';

export function RotationsplanCard({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [cardElement, setCardElement] = useState<HTMLDivElement | null>(null);
  const currentStation = rotationsplan.currentStation;
  const nextStation = rotationsplan.nextStation;

  return (
    <div
      ref={setCardElement}
      className="@container w-full h-full min-h-49 min-w-0 overflow-hidden bg-white rounded-md p-4 flex flex-col justify-between gap-4">
      <Mitarbeiter rotationsplan={rotationsplan} />
      {currentStation && currentStation instanceof ArbeitsbereichStation && (
        <Arbeitsbereich arbeitsbereichStation={currentStation} />
      )}
      {!currentStation &&
        nextStation &&
        nextStation instanceof ArbeitsbereichStation && (
          <Arbeitsbereich arbeitsbereichStation={nextStation} isNext />
        )}
      <Qualifikationen
        rotationsplan={rotationsplan}
        cardElement={cardElement}
      />
    </div>
  );
}
